import ActionDropdown from '@app/components/common/ActionDropdown';
import ActionHeader from '@app/components/common/ActionDropdown/ActionHeader';
import ActionItem from '@app/components/common/ActionDropdown/ActionItem';
import Box from '@app/components/common/Box';
import Button from '@app/components/common/Button';
import Divider from '@app/components/common/Divider';
import Icon from '@app/components/common/Icon';
import WidgetCreateOrEditModal from '@app/components/LoggedIn/Home/DashboardCreator/WidgetCreateOrEditModal/WidgetCreateOrEditModal';
import { EWidgetTypes, TWidgetTypes } from '@app/state/home/types';
import { addCustomReportElement } from '@app/state/reports/actions';
import { useAppDispatch } from '@app/state/store';
import { displayFlexRowStyles } from '@app/theme/commonStyles';
import { bindActionCreators } from '@reduxjs/toolkit';
import {
  ICustomReportComponent,
  IDashboardLayoutElement,
} from '@westondev/tableturn-core';
import { useState } from 'react';
import { useControls } from 'react-zoom-pan-pinch';
import { customReportsToolsStyles } from './styles';

interface ICustomReportsTools {
  showGridLines: boolean;
  setShowGridLines: (show: boolean) => void;
  onAddPage: () => void;
}
const CustomReportsTools = ({
  showGridLines,
  setShowGridLines,
  onAddPage,
}: ICustomReportsTools) => {
  const addCustomReportElementToChangeData = bindActionCreators(
    addCustomReportElement,
    useAppDispatch(),
  );

  const { zoomIn, zoomOut } = useControls();

  const handleOnZoomIn = () => {
    zoomIn(0.1);
  };
  const handleOnZoomOut = () => {
    zoomOut(0.1);
  };

  const [modalState, setModalState] = useState<{
    isActive: boolean;
    widgetType: TWidgetTypes | null;
  }>({
    isActive: false,
    widgetType: null,
  });

  const handleCreateElement = (widgetType: TWidgetTypes) => {
    setModalState({
      isActive: true,
      widgetType,
    });
  };

  const handleCreateWidget = (newWidget: ICustomReportComponent) => {
    switch (newWidget.type) {
      case EWidgetTypes.BAR_CHART:
        addCustomReportElementToChangeData({
          newElement: {
            id: '0',
            w: 12,
            h: 6,
          } as IDashboardLayoutElement,
          neWidget: newWidget,
        });
        break;
      case EWidgetTypes.PIE_CHART:
        addCustomReportElementToChangeData({
          newElement: {
            id: '0',
            w: 12,
            h: 6,
          } as IDashboardLayoutElement,
          neWidget: newWidget,
        });
        break;
      case EWidgetTypes.DATA_TABLE:
        addCustomReportElementToChangeData({
          newElement: {
            id: '0',
            w: 12,
            h: 6,
          } as IDashboardLayoutElement,
          neWidget: newWidget,
        });
        break;
      default:
        break;
    }
  };

  return (
    <>
      <Box csx={customReportsToolsStyles}>
        <Box csx={[displayFlexRowStyles, { gap: '8px' }]}>
          <Box csx={{ width: '100px' }}>
            <ActionDropdown
              direction="bottom-right"
              trigger={
                <Button
                  className="insert"
                  icon={<Icon name="MdAdd" />}
                  csx={{ width: '100px' }}>
                  Insert
                </Button>
              }>
              <ActionHeader>Page</ActionHeader>
              <ActionItem
                icon={<Icon name="MdInsertDriveFile" />}
                onClick={onAddPage}>
                Blank Page
              </ActionItem>
              <ActionHeader>Widgets</ActionHeader>
              <ActionItem
                icon={<Icon name="MdBarChart" />}
                onClick={() => {
                  handleCreateElement('barChart');
                }}>
                Bar Chart
              </ActionItem>
              <ActionItem
                icon={<Icon name="MdPieChart" />}
                onClick={() => {
                  handleCreateElement('pieChart');
                }}>
                Pie Chart
              </ActionItem>
              <ActionItem
                icon={<Icon name="MdSubject" />}
                onClick={() => {
                  handleCreateElement('dataTable');
                }}>
                Summary Table
              </ActionItem>
            </ActionDropdown>
          </Box>
        </Box>

        <Box csx={[displayFlexRowStyles, { gap: '8px' }]}>
          <Button
            className="tool"
            icon={<Icon name="MdZoomOut" size="28px" />}
            onClick={handleOnZoomOut}
          />
          <Button
            className="tool"
            icon={<Icon name="MdZoomIn" size="28px" />}
            onClick={handleOnZoomIn}
          />
          <Divider direction="vertical" csx={{ height: '40px' }} />
          <Button
            className="tool"
            variant={showGridLines ? 'active' : 'secondary'}
            icon={<Icon name="MdGridOn" />}
            onClick={() => {
              setShowGridLines(!showGridLines);
            }}
          />
        </Box>
      </Box>

      <WidgetCreateOrEditModal
        widgetType={modalState.widgetType}
        isActive={modalState.isActive}
        onModalClose={() =>
          setModalState({
            isActive: false,
            widgetType: null,
          })
        }
        onCreateWidget={newWidget => {
          if (modalState.widgetType)
            handleCreateWidget({
              ...newWidget,
              locationCustomReportId: 0,
              page: 0,
            });
        }}
        mode="create"
      />
    </>
  );
};

export default CustomReportsTools;
